module.exports = __webpack_public_path__ + "img/h4.8deeecd8.png";